import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { STATE_STATUS } from "../../constants";
import { fetchCompanySyncRequest, fetchCompanySyncRequestCount, setTenor, updatingTenor, updateTenor, fetchCompanySyncRequestProcessReject } from "./actions";
import {
    List as AntList,
    Card,
    Button,
    Icon,
    Input,
    Select,
    Modal,
    Spin,
    message
} from "antd";
import { OrderedMap, Map, List } from "immutable";
import moment from "moment";
import _debounce from "lodash/debounce";
import CompanyLosService from "./services/company-los-services";
import CompanyDataSyncProcessForm from "./forms/company-data-sync-process-form";
import { ERP_REQUEST_SOURCE } from "./constants/enums";
import "styles/sync-req.css";

export const BASE_URL = (function() {
    return process.env.BASE_URL;
})();

const { TextArea } = Input;
const { Option } = Select;

const CARDS = new OrderedMap({
    "pending": {
        label: "Pending",
        key: "pending",
        value: 2,
        className: "total_request_invoices"
    },
    "processing": {
        label: "Processing",
        key: "processing",
        value: 4,
        className: "total_request_pending_invoices"
    },
    "completed": {
        label: "Completed",
        key: "completed",
        value: 5,
        className: "total_request_verified_invoices"
    }
});
class CompanySyncRequest extends Component {

    state = {
        status: 2,
        values: {},
        search: "",
        openRejectModal: false,
        openModal: false,
        selectedItemData: {},
        remark: "",
        loading: false,
        masterTenorList: new List([]),
        request_type: null,
        openLinkModal: false,
        linkListing: new List([]),
        selected_row_data: null,
        filteredSyncData: [],
        syncType: "",
        filteredSyncDataState: false
    };

    onStatusChange = _ => {
        this.setState({
            status: _,
            search: "",
            filteredSyncDataState: false
        }, () => {
            // if (this.props.syncRequest.getIn([this.state.status, "status"]) !== STATE_STATUS.FETCHED) {
            // }
            this.props.fetchCompanySyncRequest(this.state.status, 1, "");
        });
    }

    componentDidMount() {
        this.fetchTenorMasterList();
        this.props.fetchCompanySyncRequestCount();
        this.props.fetchCompanySyncRequest(this.state.status, 1, this.state.search);
    }

    fetchTenorMasterList = () => {
        CompanyLosService.tenorMasterList().then(_ => {
            this.setState({
                masterTenorList: new List(_.data)
            });
        });
    }

    componentDidUpdate() {
        if (this.props.processRejectStatus === STATE_STATUS.FETCHED && this.state.loading) {
            this.setState({
                loading: false,
                openModal: false,
                openRejectModal: false,
                selectedItemData: {},
                remark: "",
                values: {},
                filteredSyncDataState: false,
            });
        }
        if (this.props.processRejectStatus === STATE_STATUS.FETCH_FAILED && this.state.loading) {
            this.setState({
                loading: false,
            });
        }
        if (this.props.syncRequest.getIn([this.state.status, "status"]) === STATE_STATUS.FETCHED && this.props.syncRequest.getIn([this.state.status, "status"]) === "FETCHED" && this.state.filteredSyncDataState === false){
            this.setState({
                filteredSyncData: this.props.syncRequest.getIn([this.state.status, "data"]) && this.props.syncRequest.getIn([this.state.status, "data"]).toJS(),
                filteredSyncDataState: true
            });
        }
        if (this.props.syncRequest.getIn([this.state.status, "status"]) === STATE_STATUS.FETCHED && this.props.syncRequest.getIn([this.state.status, "status"]) === "FETCHED" && this.props.tenorStatus === "UPDATE"){
            const dataSyncRequest = this.props.syncRequest.getIn([this.state.status, "data"]) && this.props.syncRequest.getIn([this.state.status, "data"]).toJS();
            const searchValue = this.state.search;
            const syncTypeVal = this.state.syncType;
            let filteredData = dataSyncRequest;

            if(searchValue){
                filteredData = dataSyncRequest && dataSyncRequest.filter(el=>{
                    return(
                        el.company?.name?.toLowerCase().includes(searchValue.toLowerCase().trim()) || el.company.gstin?.toLowerCase().startsWith(searchValue.toLowerCase().trim()) || el.id.toString().startsWith(searchValue.trim())
                    );
                });
            }
            if(syncTypeVal){
                filteredData = filteredData && filteredData.filter(el=>{
                    if(syncTypeVal === "auto"){
                        console.log("inside syncTypeVal if auto", syncTypeVal);
                        return el.request_type === 1;
                    }else if(syncTypeVal === "manual"){
                        return el.request_type === 2;   
                    }
                    else if(syncTypeVal === "all"){
                        return el;
                    }
                });
            }
            this.setState({filteredSyncData: filteredData});
            this.props.updatingTenor();
        }
    }

    renderCards = () => {
        return (
            <Card header={null} bordered={false} className={"p-0 border-none no-shadow mt-015 review-invoices-card"} style={{ width: "80%" }}>
                {CARDS.map((_, k) =>
                    <div className={this.state.status === _.value ? "active-card" : ""} onClick={() => this.onStatusChange(_.value)} key={k}>
                        <h2 className={"fw-500-m-0"}>{this.props.countData.get(`${_.value}`) || 0}</h2>
                        <span className={_.className}>{_.label}</span>
                    </div>
                ).toList()}
            </Card>
        );
    }

    onSearch = _debounce(() => {
        const dataSyncRequest = this.props.syncRequest.getIn([this.state.status, "data"]) && this.props.syncRequest.getIn([this.state.status, "data"]).toJS();
        const searchValue = this.state.search;
        let filteredData = dataSyncRequest;
        const syncTypeVal = this.state.syncType;
        if(syncTypeVal){
            filteredData = filteredData && filteredData.filter(el=>{
                return syncTypeVal === "auto" ? el.request_type === 1 : syncTypeVal === "manual" ? el.request_type === 2 : syncTypeVal === "all" ? el  : null;
            });
        }
        filteredData = searchValue.length>0 ? filteredData && filteredData.filter(el=>{
            return(
                el.company?.name?.toLowerCase().includes(searchValue.toLowerCase().trim()) || el.company.gstin?.toLowerCase().startsWith(searchValue.toLowerCase().trim()) || el.id.toString().startsWith(searchValue.trim())
            );
        }) : filteredData;
        this.setState({filteredSyncData: filteredData});
        // this.props.fetchCompanySyncRequest(this.state.status, 1, this.state.search);
    }, 800);


    onChangeReason = (selectedOption) =>{
        this.setState({syncType: selectedOption});
        const dataSyncRequest = this.props.syncRequest.getIn([this.state.status, "data"]) && this.props.syncRequest.getIn([this.state.status, "data"]).toJS();
        const searchValue = this.state.search;
        let filteredData = dataSyncRequest;
        if(searchValue){
            filteredData = dataSyncRequest && dataSyncRequest.filter(el=>{
                return(
                    el.company?.name?.toLowerCase().includes(searchValue.toLowerCase().trim()) || el.company.gstin?.toLowerCase().startsWith(searchValue.toLowerCase().trim()) || el.id.toString().startsWith(searchValue.trim())
                );
            });
        }
        filteredData = filteredData && filteredData.filter(el=>{
            return selectedOption === "auto" ? el.request_type === 1 : selectedOption === "manual" ? el.request_type === 2 : selectedOption === "all" ? el  : null;
        });
        this.setState({filteredSyncData: filteredData});
    }

    renderHeader = () => {
        return (
            <div className="d-flex flex-column justify-content-space-between" style={{height:"5rem"}}>
                <Input
                    value={this.state.search}
                    suffix={null}
                    prefix={<Icon style={{ fontSize: "16px", right: "10px" }} theme={"outlined"} type={"search"} />}
                    bordered={false}
                    onChange={e => this.setState({ search: e.target.value }, () => this.onSearch())}
                    className={"w-100 search-input"}
                    placeholder="Search request"
                />
                <Select
                    style={{ width: "20%"}}
                    placeholder={"Manual/Auto Sync"}
                    showSearch={true}
                    onSelect={this.onChangeReason}
                    dropdownMatchSelectWidth={false}
                >
                    <Option value="all">All</Option>
                    <Option value="manual">Manual</Option>
                    <Option value="auto">Auto</Option>
                </Select>
            </div>
        );
    }

    onTenorChange = (id, tenorId, obj) => {
        this.props.setTenor(this.state.status, obj.id, tenorId);
        this.props.updateTenor();
    }

    openRemarkModal = (id, selected_tenor, status_type, request_type, is_base_file_required, companyId, processed_file, processed_transaction_file) => {
        let selected_row_data = {
            processed: processed_file,
            processed_transaction: processed_transaction_file
        };
        if (status_type === 6) {
            this.setState({
                openRejectModal: true,
                selectedItemData: {
                    id,
                    is_base_file_required,
                    request_type,
                    selected_tenor,
                    status_type,
                    companyId,
                    selected_row_data
                }
            });
        } else {
            if (selected_tenor) {
                this.setState({
                    openModal: true,
                    selectedItemData: {
                        id,
                        selected_tenor,
                        is_base_file_required,
                        request_type,
                        status_type,
                        companyId,
                        selected_row_data
                    }
                });
            }
        }
    }

    downloadLedger = (_) => {
        const link = document.createElement("a");
        link.href = _.ledgers_archive;
        if(_.ledgers_archive) {
            link.setAttribute("download", "file");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } else {
            message.error("No File available to Download");
        }
    }

    downloadProcessedFile = (_) => {
        const link = document.createElement("a");
        link.href = _.processed_file;
        if(_.processed_file) {
            link.setAttribute("download", "file");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } else {
            message.error("No File available to Download");
        }
    }

    downloadProcessedTransaction = (_) => {
        const link = document.createElement("a");
        link.href = _.processed_transaction_file;
        if(_.processed_transaction_file) {
            link.setAttribute("download", "file");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } else {
            message.error("No File available to Download");
        }
    }

    openVisibilityDetail = (_) => {
        let companyName = _.company.name;
        if(companyName.includes("/")) {
            companyName = companyName.replace("/", "");
        }
        this.props.history.push({
            pathname: `/app/companies/sync/request/${_.company && _.company.id}/${companyName}`
        });
    }

    openLinkListView = (_, key) => {
        let linkList = [];
        if(key == "processed"){
            _.ledger_files.processedFileLinkList.map((item) => {
                let data = {
                    ledger_file: item.ledger_file,
                    ledger_file_name: item.ledger_file_name
                };
                linkList.push(data);
            });
            this.setState({
                linkListing: linkList
            }, () => {this.setState({openLinkModal: true});});
        }else if(key == "unprocessed"){
            _.ledger_files.unProcessedFileLinkList.map((item) => {
                let data = {
                    ledger_file: item.ledger_file,
                    ledger_file_name: item.ledger_file_name
                };
                linkList.push(data);
            });
            this.setState({
                linkListing: linkList
            }, () => {this.setState({openLinkModal: true});});
        }else{
            let total = _.ledger_files.processedFileLinkList.concat(_.ledger_files.unProcessedFileLinkList);
            console.log("total", total);
            total.map((item) => {
                let data = {
                    ledger_file: item.ledger_file,
                    ledger_file_name: item.ledger_file_name
                };
                linkList.push(data);
            });
            this.setState({
                linkListing: linkList
            }, () => {this.setState({openLinkModal: true});});
        }
        console.log("linklist", linkList);
    }

    renderListItem = (_, key) => {
        if (this.state.status === 2) {
            return (
                <React.Fragment>
                    <AntList.Item
                        key={key}
                        className={"w-100 mt-10 cursor-pointer border-none bg-white d-flex flex-column"}
                    >
                        <div className={"w-100 border-bottom d-flex pb-5 flex-row align-items-center justify-content-space-between"}>
                            <div style={{
                                width: "30%"
                            }}>
                                <h3 className={"m-0"} style={{
                                    fontSize: "14px",
                                    fontWeight: 600
                                }}>
                                    {_.company && _.company.name + " - " + _.id + " - " + _.company.gstin}
                                </h3>
                                <span style={{ color: "#49B8FF", fontSize: 14 }}>{_.erp_software && _.erp_software.name || "Other"}</span>
                            </div>
                            {(_.request_type === 2 && this.state.status === 2) &&
                            <div style={{width: "20%"}} className={"d-flex flex-column align-items-center"}>
                                <Button style={{
                                    color: "#45BE93",
                                    border: "0.6px solid #45BE93"
                                }} onClick={() => this.downloadLedger(_)} type={"default"} shape={"round"}>
                                    Ledger Download <Icon type={"download"} />
                                </Button>
                            </div>
                            }
                            <div className={"d-flex flex-row justify-content-space-between"}>
                                <Button 
                                    style={{
                                        color: "#FF808B",
                                        border: "0.6px solid #FF808B"
                                    }}
                                    onClick={() => 
                                        this.openRemarkModal(_.id, 
                                            null,6, _.request_type, _.erp_software.is_base_file_required, _.company.id, _.proc
                                        )
                                    } className={"ml-10"} type={"default"} shape={"round"}
                                >
                                    Reject
                                </Button>
                                {(this.state.status === 2) && <div>
                                    <Select style={{
                                        width: "120px",
                                        marginRight: "-30px"
                                    }} className={"select-opt ml-10 fb-30"} placeholder={"Tenor"} onChange={(val) => this.onTenorChange(key, val, _)} value={_.selected_tenor}>
                                        {_.tenor !== null ? 
                                            [_.tenor].map((__, k) =>{
                                                return(
                                                    <Option key={k} value={__.id} >{__.tenor_in_days}</Option>
                                                );})
                                            : this.state.masterTenorList.map((__, k) =>
                                                <Option key={k} value={__.id} >{__.tenor_in_days}</Option>
                                            )
                                        }
                                    </Select>
                                    <Button
                                        style={{
                                            backgroundColor: "#49B8FF",
                                            color: "#ffffff"
                                        }}
                                        onClick={() =>{
                                            return( 
                                                this.openRemarkModal(_.id, 
                                                    _.selected_tenor, 4, _.request_type, _.erp_software.is_base_file_required, _.company.id, _.processed_file , _.processed_transaction_file
                                                )
                                            );}} shape={"round"} >Process <Icon style={{ fontSize: "10px" }} type={"right"}/></Button>
                                </div>}
                            </div>
                        </div>
                        <div className={"pt-5 w-100 d-flex flex-row align-items-center justify-content-space-between"} style={{borderBottom: "1px solid #F6F6F6"}}>
                            <div className={"d-flex mr-15 flex-column"}>
                                <span style={{ textAlign: "center" }}><strong>{moment(_.create_date).format("Do MMM'YY h:mm a")}</strong></span>
                                <span style={{ opacity: 0.8, textAlign: "center" }}>Request Date</span>
                            </div>
                            {_.contact_person && <div className={"d-flex flex-column align-items-center"}>
                                <span style={{ textAlign: "center" }}><strong>{_.contact_person.full_name} <br/> {_.contact_person.phone ? _.contact_person.phone : null}</strong></span>
                                <span style={{ opacity: 0.8, textAlign: "center" }}>Contact Person</span>
                            </div>}
                            {_.request_type !== 2 && <div className={"d-flex ml-15 flex-column  align-items-center"}>
                                <span><strong>{_.scheduled_at && moment(_.scheduled_at).format("Do MMM'YY HH:mm a") || "---"}</strong></span>
                                <span style={{ opacity: 0.8 }}>Contact Date</span>
                            </div>}
                            <div className={"d-flex flex-column align-items-center"}>
                                <span style={{ textAlign: "center" }}><strong>{_.request_source ? ERP_REQUEST_SOURCE.findKey(__ => __ === _.request_source) : "--"}</strong></span>
                                <span style={{ opacity: 0.8, textAlign: "center" }}>ERP Request Source</span>
                            </div>
                            <div className={"d-flex flex-column align-items-center"}>
                                <span style={{ textAlign: "center" }}><strong>{(_.request_by && _.request_by.full_name) || "--"}</strong></span>
                                <span style={{ opacity: 0.8, textAlign: "center" }}>Requested By</span>
                            </div>
                        </div>
                        <hr />
                        {/* <div className={"w-100 border-bottom pb-5"}>
                            <div className={"d-flex flex-row align-items-center justify-content-space-between"}>
                                <div>
                                    <h3 className={"m-0"}>
                                        {_.company && _.company.name}
                                    </h3>
                                    <span style={{ color: "#49B8FF", fontSize: 18 }}>{_.erp_software && _.erp_software.name || "Other"}</span>
                                </div>
                                {_.contact_person && <div className={"d-flex flex-column"}>
                                    <span><strong>{_.contact_person.full_name} ({_.contact_person.phone})</strong></span>
                                    <span className={"mt-5"} style={{ opacity: 0.8 }}>Contact Person</span>
                                </div>}
                                {_.request_type === 2 && 
                                    <Button onClick={() => this.downloadLedger(_)} type={"default"} shape={"round"}>
                                        Ledger Download
                                    </Button>
                                }
                            </div>
                        </div>
                        <div  className={"pt-5 w-100 d-flex flex-row align-items-center justify-content-space-between"}>
                            <div className={"d-flex flex-row align-items-center"} style={{
                                justifyContent: "flex-start"
                            }}>
                                <div className={"d-flex mr-15 flex-column"}>
                                    <span><strong>{moment(_.created_at).format("Do MMM'YY")}</strong></span>
                                    <span className={"mt-5"} style={{ opacity: 0.8 }}>Request Date</span>
                                </div>
                                {_.request_type !== 2 && <div className={"d-flex ml-15 flex-column"}>
                                    <span><strong>{_.scheduled_at && moment(_.scheduled_at).format("Do MMM'YY") || "---"}</strong></span>
                                    <span className={"mt-5"} style={{ opacity: 0.8 }}>Contact Date</span>
                                </div>}
                            </div>
                            <div>
                                {(this.state.status === 2) && <div>
                                    <Select placeholder={"Tenor"} onChange={(val) => this.onTenorChange(key, val)} value={_.selected_tenor} className={"ml-10"} style={{ width: "200px" }} >
                                        {_.tenor !== null ? 
                                            [_.tenor].map((__, k) => 
                                                <Option key={k} value={__.id} >{__.tenor_in_days}</Option>
                                            )
                                            : this.state.masterTenorList.map((__, k) => 
                                                <Option key={k} value={__.id} >{__.tenor_in_days}</Option>
                                            )
                                        }
                                    </Select>
                                    <Button onClick={() => this.openRemarkModal(_.id, _.selected_tenor, 4)} type={"primary"} shape={"round"}>Process</Button>
                                    <Button onClick={() => this.openRemarkModal(_.id, null, 6)} className={"ml-10"} type={"danger"} shape={"round"}>Reject</Button>
                                </div>}
                            </div>
                        </div> */}
                    </AntList.Item>
                    {(_.request_type === 2 && this.state.status === 2) &&
                        <React.Fragment>
                            <div style={{ padding: "24px", backgroundColor: "#e2dbff" }}>
                                <div style={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>Automated Files</div>
                                <div className={"pt-5 w-100 d-flex flex-row align-items-center justify-content-space-between"}>
                                    <div className={"d-flex mr-15 d-flex"}>
                                        <span style={{ textAlign: "center" }}><strong>Derived_ERP:</strong> {_.derived_erp_name}</span>
                                        <span style={{ textAlign: "center", marginLeft: "20px" }}><strong>Is_Tally:</strong> {_.is_erp?.toString()}</span>
                                        <span style={{ textAlign: "center", marginLeft: "20px" }}><strong>File Format:</strong> {_.first_file_extension?.toString()}</span>
                                    </div>
                                </div>
                                <div className={"pt-5 w-100 d-flex flex-row align-items-center justify-content-space-between"}>
                                    {/* <div className={"d-flex mr-15 flex-column"}>
                                            <Button style={{
                                                color: "#45BE93",
                                                border: "0.6px solid #45BE93"
                                            }} onClick={() => this.downloadProcessedFile(_)} type={"default"} shape={"round"}>
                                                Processed Ledger <Icon type={"download"} />
                                            </Button>
                                        </div>
                                        <div className={"d-flex flex-column align-items-center"}>
                                            <Button style={{
                                                color: "#45BE93",
                                                border: "0.6px solid #45BE93"
                                            }} onClick={() => this.downloadProcessedTransaction(_)} type={"default"} shape={"round"}>
                                                Processed Ledger Transactions <Icon type={"download"} />
                                            </Button>
                                        </div> */}
                                    <div className={"d-flex flex-column align-items-center"}>
                                        <Button style={{
                                            color: "#45BE93",
                                            border: "0.6px solid #45BE93"
                                        }} type={"default"} shape={"round"}>
                                            <a style={{ color: "rgb(69, 190, 147) !important" }} target={"_blank"} rel="noopener noreferrer" href={BASE_URL + "/company/erp_unprocessed_files/" + _.id}>Download All File <Icon type={"download"} /></a>
                                        </Button>
                                    </div>
                                    <div className={"d-flex flex-column align-items-center"}>
                                        <p><a onClick={() => this.openLinkListView(_, "processed")}>{_.ledger_files.processedFileCount} Files</a> out of <a onClick={() => this.openLinkListView(_, "total_file")}>{_.ledger_files.totalFilesCount} Files</a> Processed <a onClick={() => this.openLinkListView(_, "unprocessed")}>{_.ledger_files.unProcessedFileCount} Files</a> unprocessed</p>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    }
                </React.Fragment>
            );
        } else if (this.state.status === 4) {
            return (
                <AntList.Item
                    key={key}
                    className={"w-100 mt-10 cursor-pointer border-none mb-5 bg-white d-flex flex-column"}
                >
                    <div className={"w-100 d-flex pb-5 flex-row align-items-center justify-content-space-between"}>
                        <div style={{
                            width: "30%"
                        }}>
                            <h3 className={"m-0"} style={{
                                fontSize: "14px",
                                fontWeight: 600
                            }}>
                                {_.company && _.company.name + " - " + _.id + " - " + _.company.gstin}
                            </h3>
                            <span style={{ color: "#49B8FF", fontSize: 14 }}>{_.erp_software && _.erp_software.name || "Other"}</span>
                        </div>
                        <div className={"d-flex flex-row align-items-center justify-content-space-between pb-5"} style={{
                            borderBottom: "0.5px solid #e7e7e7",
                            width: "70%"
                        }}>
                            <div className={"d-flex mr-15 flex-column"}>
                                <span style={{ textAlign: "center" }}><strong>{moment(_.create_date).format("Do MMM'YY")}</strong></span>
                                <span className={"mt-5"} style={{ opacity: 0.8, textAlign: "center" }}>Request Date</span>
                            </div>
                            <div className={"d-flex mr-15 flex-column"}>
                                <span style={{ textAlign: "center" }}><strong>{moment(_.create_date).format("Do MMM'YY")}</strong></span>
                                <span className={"mt-5"} style={{ opacity: 0.8, textAlign: "center" }}>Processed Date</span>
                            </div>
                            <div className={"d-flex flex-column align-items-center"}>
                                <span style={{ textAlign: "center" }}><strong>{_.request_source ? ERP_REQUEST_SOURCE.findKey(__ => __ === _.request_source) : "--"}</strong></span>
                                <span style={{ opacity: 0.8, textAlign: "center" }}>ERP Request Source</span>
                            </div>
                            <div className={"d-flex flex-column align-items-center"}>
                                <span style={{ textAlign: "center" }}><strong>{(_.request_by && _.request_by.full_name) || "--"}</strong></span>
                                <span style={{ opacity: 0.8, textAlign: "center" }}>Requested By</span>
                            </div>
                        </div>
                        {/* <Icon style={{ fontSize: "16px" }} onClick={this.openVisibilityDetail.bind(null, _.id)} theme={"outlined"} type={"caret-right"} /> */}
                    </div>
                    <div className={"w-100 d-flex justify-content-flex-end"}>
                        <Button style={{
                            color: "#45BE93",
                            border: "0.6px solid #45BE93"
                        }} onClick={() => this.downloadLedger(_)} shape={"round"} type={"default"}>
                            Ledger Download <Icon type={"download"} />
                        </Button>
                        <Button style={{
                            color: "#45BE93",
                            border: "0.6px solid #45BE93"
                        }} onClick={() => this.downloadLedger(_)} shape={"round"} type={"default"}>
                            Auto Generated File <Icon type={"download"} />
                        </Button>
                    </div>
                </AntList.Item>
            );
        } else {
            return (
                <AntList.Item
                    className={"w-100 mt-10 border-none mb-5 bg-white d-flex flex-row align-items-center justify-content-space-between"}
                >
                    <div style={{width: "30%"}}>
                        <div className={"d-flex flex-row align-items-center"}>
                            <h3 className={"m-0"} style={{
                                fontSize: "14px",
                                fontWeight: 600
                            }}>
                                {_.company && _.company.name + " - " + _.id + " - " + _.company.gstin}
                            </h3>
                        </div>
                        <span className={"mr-10 cursor-pointer pending-req"} >{_.status || "Completed"}</span>
                        <span style={{ fontWeight: 300, opacity: 0.6 }} className={"mr-5 total-req"}>{_.completed_on && moment(_.completed_on).format("MMM Do, YYYY")}</span>
                    </div>
                    <div style={{width: "20%"}} className={"d-flex flex-column align-items-center"}>
                        <Button style={{
                            color: "#45BE93",
                            border: "0.6px solid #45BE93"
                        }} onClick={() => this.downloadLedger(_)} type={"default"} shape={"round"}>
                            Ledger Download <Icon type={"download"} />
                        </Button>
                        <Button style={{
                            color: "#45BE93",
                            border: "0.6px solid #45BE93"
                        }} onClick={() => this.downloadLedger(_)} shape={"round"} type={"default"}>
                            Auto Generated File <Icon type={"download"} />
                        </Button>
                        
                    </div>
                    <div style={{
                        width: "50%"
                    }} className={"d-flex flex-row align-items-center justify-content-space-between"}>
                        <div>
                            <h3 className={"ml-05 cursor-pointer pending-req m-0"} >{((_.ledger_status.find(_ => _.final_status === 1) || {}).count || 0)}</h3>
                            <span style={{ color: "#27AE60" }} className={"ml-05 cursor-pointer pending-req"} >Approved</span>
                        </div>
                        <div>
                            <h3 className={"ml-05 cursor-pointer pending-req m-0"} >{((_.ledger_status.find(_ => _.final_status === 3) || {}).count || 0)}</h3>
                            <span style={{ color: "#F2994A" }} className={"ml-05 cursor-pointer pending-req"} >In Review</span>
                        </div>
                        <div>
                            <h3 className={"ml-05 cursor-pointer pending-req m-0"} >{((_.ledger_status.find(_ => _.final_status === 2) || {}).count || 0)}</h3>
                            <span style={{ color: "#FF808B" }} className={"ml-05 cursor-pointer pending-req"} >Rejected</span>
                        </div>
                        <Icon style={{ fontSize: "16px" }} onClick={this.openVisibilityDetail.bind(null, _)} theme={"outlined"} type={"caret-right"} />
                    </div>
                </AntList.Item>
            );
        }
    };

    onLoadMore = () => {
        if (
            this.props.syncRequest.getIn([this.state.status, "status"]) !== STATE_STATUS.FETCHING &&
            this.props.syncRequest.getIn([this.state.status, "count"]) > this.props.syncRequest.getIn([this.state.status, "pageNo"]) * 300
        ) {
            this.props.fetchCompanySyncRequest(
                this.state.status,
                this.props.syncRequest.getIn([this.state.status, "pageNo"]) + 1,
                this.state.search,
                300
            );
        }
    }

    renderLoadMore = () => {
        if (this.props.syncRequest.getIn([this.state.status, "count"]) > this.props.syncRequest.getIn([this.state.status, "pageNo"]) * 300) {
            return (
                <div className={"align-items-center justify-content-center d-flex"}>
                    <Button onClick={this.onLoadMore}>Load More</Button>
                </div>
            );
        } else {
            return;
        }
    }

    onTextAreaChange = e => {
        this.setState({
            remark: e.target.value
        });
    }

    onRemarkSubmit = () => {
        const { id, status_type } = this.state.selectedItemData;
        this.props.fetchCompanySyncRequestProcessReject(
            id,
            null,
            {
                current_status: status_type,
                remarks: this.state.remark
            },
            null,
            null
        );
        this.setState({
            loading: true
        });
    }


    onCancel = () => {
        this.setState({
            openModal: false,
            loading: false,
            selectedItemData: {},
            remark: ""
        });
    }

    renderRejectModal = () => (
        <Modal
            visible={this.state.openRejectModal}
            onCancel={() => {
                this.setState({
                    openRejectModal: false,
                    selectedItemData: {},
                    remark: ""
                });
            }}
            closable={true}
            width={520}
            destroyOnClose={true}
            footer={null}
        >
            <div>
                <span className={"mt-10"}>
                    Remark:
                </span>
                <TextArea
                    className={"mt-10"}
                    placeholder={"Remark"}
                    value={this.state.remark}
                    onChange={this.onTextAreaChange}
                />
                <Button disabled={this.state.selectedItemData.status_type === 6 && !this.state.remark} onClick={this.onRemarkSubmit} className={"mt-10 w-100"} type={"primary"}>
                    {this.state.loading ? <Icon type={"loading"} /> : null}
                    Submit
                </Button>
            </div>
        </Modal>
    )

    onSubmit = (values) => {
        const { id, selected_tenor, status_type, is_base_file_required } = this.state.selectedItemData;
        let data = {
            ...values,
            brands: values.brands.map(_ => _.id),
            primary_rm: values.primary_rm.id,
            program_anchor: values.program_anchor.id,
            current_status: status_type,
            tenor_id: selected_tenor
        };
        if (is_base_file_required && values.base_file) {
            let formData = new FormData();
            formData.append("base_file", values.base_file);
            // automatedFile && formData.append("base_file_url", automatedFile);
            // formData.append("use_automate_file", values.use_automate_file);
            formData.append("file_feedback", values.file_feedback);
            this.props.fetchCompanySyncRequestProcessReject(id, is_base_file_required, data, formData, null);
        } else {
            this.props.fetchCompanySyncRequestProcessReject(id, is_base_file_required, data, null, null);
        }
        this.setState({
            loading: true,
            values: values
        });
    }

    render() {
        return (
            <div className={"d-flex flex-column align-items-center p-20"}>
                <Modal footer={null} visible={this.state.openLinkModal} onOk={() => this.setState({openLinkModal: false})} onCancel={() => this.setState({openLinkModal: false})}>
                    {
                        this.state.linkListing.map((item) => {
                            return (
                                <p key={item.ledger_file}>{item.ledger_file}</p>
                            );
                        })
                    }
                </Modal>
                <h1 className={"fw-700-m-0"} style={{ fontSize: "26px" }}>Data Sync Requests</h1>
                {/* <span style={{ fontSize: "18px" }} className={"total_request_invoices"}>20 new requests</span> */}
                {this.renderCards()}
                {(this.props.syncRequest.getIn([this.state.status, "status"]) || STATE_STATUS.FETCHING) === STATE_STATUS.FETCHING ?
                    <Spin className={"mt-10"} /> :
                    <AntList
                        border={false}
                        className={"border-none padd-0"}
                        bordered
                        style={{ width: "80%" }}
                        footer={null}
                        loadMore={this.renderLoadMore()}
                        header={this.renderHeader()}
                        dataSource={new List(this.state.filteredSyncData) || new List([])}
                        renderItem={this.renderListItem}
                    />
                }
                {this.state.openModal && <CompanyDataSyncProcessForm
                    onSubmit={this.onSubmit}
                    loading={this.state.loading}
                    companyId={this.state.selectedItemData.companyId}
                    is_base_file_required={this.state.selectedItemData.is_base_file_required}
                    request_type={this.state.selectedItemData.request_type}
                    selected_row_data={this.state.selectedItemData.selected_row_data}
                    values={new OrderedMap(this.state.values)}
                    visible={this.state.openModal}
                    processRejectStatus={this.props.processRejectStatus}
                    onCancel={this.onCancel}
                />}
                {this.renderRejectModal()}
            </div>
        );
    }
}

CompanySyncRequest.propTypes = {
    fetchCompanySyncRequest: PropTypes.func,
    fetchCompanySyncRequestCount: PropTypes.func,
    countStatus: PropTypes.string,
    countData: PropTypes.object,
    syncRequest: PropTypes.object,
    setTenor: PropTypes.func,
    updateTenor: PropTypes.func,
    updatingTenor: PropTypes.func,
    tenorStatus: PropTypes.func,
    fetchCompanySyncRequestProcessReject: PropTypes.func,
    processRejectStatus: PropTypes.string,
    history: PropTypes.object
};

const mapStateToProps = state => {
    return {
        countData: state.companyLosProfiles.getIn(["syncRequest", "count", "data"]) || new Map({}),
        countStatus: state.companyLosProfiles.getIn(["syncRequest", "count", "status"]) || STATE_STATUS.FETCHING,
        syncRequest: state.companyLosProfiles.getIn(["syncRequest", "syncList"]) || new Map({}),
        processRejectStatus: state.companyLosProfiles.getIn(["syncRequest", "processReject", "status"]) || STATE_STATUS.UNFETCHED,
        tenorStatus: state.companyLosProfiles.getIn(["dataSyncRequest", "tenorStatus"]),
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCompanySyncRequest,
            fetchCompanySyncRequestCount,
            setTenor,
            updatingTenor,
            updateTenor,
            fetchCompanySyncRequestProcessReject
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompanySyncRequest);